import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { useLotSizingPurchaseOrderDraft } from './lot-sizing-purchase-order-draft-context';

export function LotSizingWithPurchaseOrderCancel() {
  const { t } = useTranslation('common');
  const { hasChanges, resetDraft } = useLotSizingPurchaseOrderDraft();

  return (
    <Button
      disabled={!hasChanges}
      onClick={resetDraft}
      type='button'
      variant='outline'
    >
      {t('cancel')}
    </Button>
  );
}
